import Translation, { DEFAULT_MESSAGE_FALLBACK } from './Translation';

export default Translation;

export { DEFAULT_MESSAGE_FALLBACK };
